// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.
/**
 * A small self-authored example doodle, so a solo visitor can see the tool draw
 * and export something in one click without needing a second person. Returns
 * partial shapes (no author/Lamport) in logical board coords; the caller stamps
 * and commits them exactly like real strokes.
 */
import type { ShapeKind } from './types.ts';

export interface SampleShape {
  kind: ShapeKind;
  color: string;
  width: number;
  points: number[];
  text?: string;
  fontSize?: number;
}

const INK = '#1f2430';
const BLUE = '#3b82f6';
const GREEN = '#30a46c';
const AMBER = '#f5c518';
const PINK = '#e93d82';

/** A friendly "hello" sketch — a sun, a house, an arrow and a label. */
export function exampleDoodle(): SampleShape[] {
  return [
    { kind: 'text', color: INK, width: 4, points: [560, 200], text: 'Draw here, together', fontSize: 54 },
    // Sun
    { kind: 'ellipse', color: AMBER, width: 10, points: [200, 300, 360, 460] },
    { kind: 'line', color: AMBER, width: 6, points: [280, 250, 280, 210] },
    { kind: 'line', color: AMBER, width: 6, points: [400, 300, 440, 280] },
    { kind: 'line', color: AMBER, width: 6, points: [160, 300, 120, 280] },
    // House
    { kind: 'rect', color: INK, width: 8, points: [640, 560, 900, 760] },
    { kind: 'pen', color: INK, width: 8, points: [630, 560, 770, 460, 910, 560] },
    { kind: 'rect', color: BLUE, width: 6, points: [700, 640, 770, 760] },
    { kind: 'rect', color: GREEN, width: 6, points: [810, 620, 870, 680] },
    // Arrow + note
    { kind: 'arrow', color: PINK, width: 8, points: [1040, 420, 1240, 560] },
    { kind: 'text', color: PINK, width: 4, points: [1020, 380], text: 'your idea →', fontSize: 40 },
    { kind: 'pen', color: GREEN, width: 6, points: [1080, 640, 1120, 700, 1180, 660, 1240, 720, 1300, 680] },
  ];
}
